// radioButtonSlice.js
import { createSlice } from "@reduxjs/toolkit";

const radioButtonSlice = createSlice({
  name: "radioButton",
  initialState: {
    selectedValue: "2", // Initially, no option is selected
  },
  reducers: {
    setRadioButtonValue: (state, action) => {
      state.selectedValue = action.payload;
    },
  },
});

export const { setRadioButtonValue } = radioButtonSlice.actions;
export default radioButtonSlice.reducer;
